module.exports = __webpack_public_path__ + "fonts/0f5cc8c05acb7406a2724545d6f38320-Roboto-Thin.ttf";